import React, { FC, useContext, useEffect, useState } from 'react';
import { observer } from "mobx-react-lite";
import { Context } from "../../index";
import { useNavigate } from "react-router-dom";
import Spinner from "../../UI/Spinner/Spinner";
import { checkPremiumStatus } from '../../services/PaymentService';
import { motion } from 'framer-motion';
import hot from './hot.gif';
import ReactGA from 'react-ga4';
import useIsMobile from "../../utils/useIsMobile";
import { BiCookie } from "react-icons/bi";
import { RiKeyFill } from "react-icons/ri";
import LoginForm from "./LoginForm";


const LoginPage: FC = () => {
    const { store } = useContext(Context);
    const navigate = useNavigate();
    const [isUser, setIsUser] = useState<boolean | null>(null);
    const [showCookieMessage, setShowCookieMessage] = useState<boolean>(true);
    const [showContent, setShowContent] = useState<boolean>(store.user.isActivated);

    // Handle cookies
    useEffect(() => {
        if (document.cookie.split(';').some((item) => item.trim().startsWith('cookieAccepted='))) {
            setShowCookieMessage(false);
        }
    }, []);

    // Initialize Google Analytics
    useEffect(() => {
        ReactGA.initialize('G-476LSLTQP7'); // Replace with your GA4 Measurement ID
    }, []);

    // Track pageview on component mount
    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    }, []);

    const loggedInUserId = store.user.id





    // Button click handlers with GA tracking using gtag
    const handleHotDealsClick = () => {
        ReactGA.gtag('event', 'click_hot_deals', {
            event_category: 'Button',
            event_label: 'Hot Deals',
            loggedinUserid: loggedInUserId // Use dynamic user ID
        });
        navigate('/hotDeals');
    };

    // const handleTrafikverketClick = () => {
    //     ReactGA.gtag('event', 'click_trafikverket', {
    //         event_category: 'Button',
    //         event_label: 'Boka Uppkörning på Trafikverket',
    //         loggedinUserid: loggedInUserId // Use dynamic user ID
    //     });
    //     window.open('https://www.trafikverket.se/logga-in/', '_blank');
    // };
    //
    // const handleGetPremiumClick = () => {
    //     ReactGA.gtag('event', 'click_get_premium', {
    //         event_category: 'Button',
    //         event_label: 'Get Premium',
    //         loggedinUserid: loggedInUserId // Use dynamic user ID
    //     });
    //     navigate('/levelup');
    // };





    // Handle cookie acceptance
    const handleAcceptCookies = () => {
        const expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
        document.cookie = `cookieAccepted=true; expires=${expires.toUTCString()}; path=/`;
        setShowCookieMessage(false);
    };

    // Check premium status when user is authenticated
    useEffect(() => {
        if (store.isAuth) {
            const checkUser = async () => {
                try {
                    const statusResponse = await checkPremiumStatus(store.user.id);
                    if (statusResponse.data) {
                        setIsUser(statusResponse.data.isUser);
                    }
                } catch (error) {
                    console.error(error);
                }
            };
            checkUser();
        }
    }, [store.isAuth, store.user.id]);

    // Update local state based on store.user.isActivated
    useEffect(() => {
        setShowContent(store.user.isActivated);
    }, [store.user.isActivated]);

    // Detect mobile screen size and update state
    const isMobile = useIsMobile(); // default breakpoint is 550px


    // Show spinner if data is loading
    if (store.isLoading) {
        return <div><Spinner /></div>;
    }

    // Render login form if not authenticated
    if (!store.isAuth) {
        return (
            <div className='jcc center mt-64 mb-32' style={{ maxWidth: 300 }}>
                <LoginForm />
            </div>
        );
    }




    return (
        <>
            <section className='jcc center mt-32' style={{ maxWidth: 350 }}>
                <h2 className='pb-16'>Välkommen till Let's roll</h2>
                <div className='center pt-32'>
                    {store.isAuth ? (
                        <>
                            Inloggad som <h3 className={'pt-16'}>{store.user.name}</h3>
                        </>
                    ) : (
                        'Please log in'
                    )}
                </div>

                {!store.user.isActivated && (
                    <div className={'pt-32'}>
                    <p style={{ fontSize: "3.5rem", color: "#4e418d" }} className={'pt-16'}>
                        <RiKeyFill/></p>
                    <p style={{ fontSize: "1.5rem" }} className={'pt-16'}>

                        Vänligen aktivera ditt konto! Vi har skickat en aktiveringslänk till den e-post du angav.
                    </p>
                    </div>
                )}

                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: showContent ? 1 : 0 }}
                    transition={{ duration: 2.1 }}
                >
                    <div className='jcc center mt-64 mb-32'>
                        <button onClick={() => navigate('/notes')} className={`${isMobile ? 'buttonstpM' : 'buttonstp'}`}>
                            Mitt övningskörnings kort
                        </button>
                        <button onClick={() => navigate('/instructor')}  className={`${isMobile ? 'buttonM' : 'button'}`}>
                            Lägg till handledare
                        </button>
                        <button onClick={handleHotDealsClick}className={`${isMobile ? 'buttonM' : 'button'}`}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={hot} alt='premium' style={{
                                    marginRight: isMobile ? '0px' : '0px', // Apply different marginRight based on isMobile
                                    marginLeft:  isMobile ? '15px' : '65px',
                                    width: '40px',
                                    marginBottom: -45,
                                    marginTop: -50 }} />
                                Hot deals
                            </div>
                        </button>
                        {/*<button onClick={handleTrafikverketClick} className={`${isMobile ? 'buttonM' : 'button'}`}>*/}
                        {/*    Uppkörning/trafikverket*/}
                        {/*</button>*/}
                        {isUser === false && ( <></>
                            // <button onClick={handleGetPremiumClick}  className={`${isMobile ? 'ghostbuttonPM' : 'ghostbuttonP'}`}>
                            //     <div style={{ display: 'flex', alignItems: 'center' }}>
                            //         <img src={star} alt='premium' style={{
                            //             marginRight: isMobile ? '-12px' : '-10px',
                            //             marginLeft: isMobile ? '-9px' : '30px',
                            //             width: '79px',
                            //             marginBottom: -50,
                            //             marginTop: -50 }} />
                            //         Get premium
                            //     </div>
                            // </button>
                        )}
                        <button onClick={() => navigate('/settings')}className={`${isMobile ? 'buttonM mt-64' : 'button mt-64'}`}>
                            Mina inställningar
                        </button>
                        <button className={`${isMobile ? 'buttonM mb-64' : 'button mb-64'}`} onClick={() => store.logout()}>
                            Log out
                        </button>
                    </div>
                </motion.div>


            </section>
            {showCookieMessage && (
                <div className='cookie-message p-16 center'>
                    <button
                        className="mb-8 p-8"
                        style={{ fontSize: "1.1rem" }}
                        onClick={handleAcceptCookies}
                    >
                        <BiCookie style={{ fontSize: "1.8rem" }} />
                        Accept
                    </button>
                    <p>We use cookies to improve your experience on our site. By continuing to use our site, you accept our use of cookies. Read more about it <a href={'/privacy'}>here.</a>
                    </p>
                </div>
            )}
        </>
    );
};

export default observer(LoginPage);
